import React, { useEffect, useState } from 'react';
import './FeaturedPopup.css';

// Reads the 'landing_popup' site_content key (same generic system used
// for the calendar info cards) and interprets its items by label rather
// than rendering them as prose lines. Shows once per browser session
// unless dismissed — sessionStorage, not localStorage, so it reappears
// on the next visit rather than being permanently dismissed forever.
export default function FeaturedPopup() {
  const [content, setContent] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('seenFeaturedPopup')) return;

    fetch('/api/site-content?keys=landing_popup')
      .then((r) => r.json())
      .then((data) => {
        if (!data.success) return;
        const raw = data.content?.landing_popup?.items || [];
        const byLabel = {};
        raw.forEach((item) => { byLabel[item.label] = item.text; });
        if (byLabel.active !== 'true') return;
        setContent(byLabel);
        setVisible(true);
      })
      .catch((err) => console.error('Error fetching featured popup:', err));
  }, []);

  function dismiss() {
    setVisible(false);
    sessionStorage.setItem('seenFeaturedPopup', 'true');
  }

  if (!visible || !content) return null;

  return (
    <div className="fp-overlay" onClick={dismiss}>
      <div className="fp-modal" onClick={(e) => e.stopPropagation()}>
        <button className="fp-close" onClick={dismiss} aria-label="Close">✕</button>
        {content.image && (
          <img className="fp-image" src={content.image} alt={content.title || ''} />
        )}
        <div className="fp-body">
          {content.title && <h2 className="fp-title">{content.title}</h2>}
          {content.tagline && <p className="fp-tagline">{content.tagline}</p>}
          {content.linkUrl && (
            <a className="mihu-btn-primary-lg fp-cta" href={content.linkUrl} onClick={dismiss}>
              {content.linkLabel || 'Learn more'}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
